import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IsBusyService {

  numWaitingTrue = signal<number>(0);

  isBusy = computed(() => {
    const numBusy = this.numWaitingTrue();
    return numBusy > 0;
  });

  setBusy(isBusy: boolean): void {
    if (isBusy) {
      this.numWaitingTrue.update((prev) => {
        return prev + 1;
      });
    } else {
      this.numWaitingTrue.update((prev) => {
        if (prev <= 0) {
          return 0;
        }
        return prev - 1;
      });
    }

  }

  resetBusy(): void {
    this.numWaitingTrue.set(0);
  }

}
